import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { SharedService } from 'src/app/shared/common-services/shared.service';
import { LoginService } from './login-service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  loginForm: FormGroup;
  loginSubmitted: boolean = false;
  errorMessage: string = null;
  confirmHide: boolean = true;
  isShown: boolean = false;

  constructor(
    private _router: Router,
    private _fb: FormBuilder,
    private _loginService: LoginService,
    private _sharedService: SharedService,
  ) {
    if (localStorage.getItem('token')?.toString()) {
      this._router.navigate(['device-management']);
    }

    this.loginForm = this._fb.group({
      username: [
        '',
        [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)],
      ],
      password: ['', [Validators.required]],
    });
  }

  get loginFormValues() {
    return this.loginForm.controls;
  }


  login() {
    this.loginSubmitted = true;
    this.errorMessage = null;
    this._loginService
      .login(
        this.loginFormValues['username'].value, this.loginFormValues['password'].value
      )
      .subscribe((res: any) => {
        if (res?.status) {
          this._sharedService.fetchTokenDetials(res?.response?.token, true);
          this._sharedService.toastrHandler({ type: 'success', msg: res?.response?.message });
        } else {
          this._sharedService.toastrHandler({ type: 'error', msg: res?.response?.message });
        }
      });
  }
}
